(function () {
  "use strict";

  /* =========================================================
     VSX9 COMPARE
     DYNAMIC SHOPIFY PRODUCT SPECIFICATIONS
     ========================================================= */

  var STORAGE_KEY = "vsx9_compare_v1";
  var EVENT_NAME = "vs:compare:updated";
  var MAX_PRODUCTS = 4;

  var state = {
    items: [],
    products: [],
    onlyDifferences: false,
    loading: false
  };


  /* =========================================================
     HELPERS
     ========================================================= */

  function getPage() {
    return document.querySelector("[data-vsx9-compare-page]");
  }

  function escapeHTML(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function firstValue() {
    for (var i = 0; i < arguments.length; i++) {
      var value = arguments[i];

      if (
        value !== undefined &&
        value !== null &&
        value !== ""
      ) {
        return value;
      }
    }

    return "";
  }

  function cleanText(value) {
    return String(value == null ? "" : value)
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalizeSpecKey(value) {
    return cleanText(value)
      .replace(/:$/, "")
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function normalizeUrl(url, handle) {
    if (url) {
      if (String(url).charAt(0) === "/") {
        return String(url);
      }

      try {
        return new URL(
          url,
          window.location.origin
        ).pathname;
      } catch (error) {
        return String(url);
      }
    }

    if (handle) {
      return "/products/" +
        encodeURIComponent(handle);
    }

    return "#";
  }


  /* =========================================================
     STORAGE
     ========================================================= */

  function readStorage() {
    try {
      var raw = localStorage.getItem(
        STORAGE_KEY
      );

      if (!raw) {
        return [];
      }

      var parsed = JSON.parse(raw);

      return Array.isArray(parsed)
        ? parsed
        : [];
    } catch (error) {
      console.warn(
        "[VSX9 Compare] Storage read failed:",
        error
      );

      return [];
    }
  }

  function normalizeItem(item) {
    if (!item || typeof item !== "object") {
      return null;
    }

    var id = firstValue(
      item.id,
      item.productId,
      item.product_id
    );

    var handle = firstValue(
      item.handle,
      item.productHandle,
      item.product_handle
    );

    if (!id && !handle) {
      return null;
    }

    return {
      id: id ? String(id) : "",
      handle: handle ? String(handle) : "",

      title: firstValue(
        item.title,
        item.productTitle,
        item.product_title,
        ""
      ),

      url: normalizeUrl(
        firstValue(
          item.url,
          item.productUrl,
          item.product_url
        ),
        handle
      ),

      image: firstValue(
        item.image,
        item.productImage,
        item.product_image,
        item.featured_image,
        ""
      ),

      price: firstValue(
        item.price,
        item.productPrice,
        item.product_price,
        ""
      ),

      comparePrice: firstValue(
        item.comparePrice,
        item.compare_price,
        ""
      ),

      vendor: firstValue(
        item.vendor,
        item.productVendor,
        item.product_vendor,
        ""
      ),

      variantId: firstValue(
        item.variantId,
        item.variant_id,
        ""
      ),

      available:
        item.available !== undefined
          ? Boolean(item.available)
          : true
    };
  }

  function normalizeItems(items) {
    if (!Array.isArray(items)) {
      return [];
    }

    var result = [];

    items.forEach(function (item) {
      var normalized = normalizeItem(item);

      if (!normalized) {
        return;
      }

      var exists = result.some(
        function (existing) {
          return (
            (
              normalized.id &&
              existing.id &&
              normalized.id === existing.id
            ) ||
            (
              normalized.handle &&
              existing.handle &&
              normalized.handle === existing.handle
            )
          );
        }
      );

      if (!exists) {
        result.push(normalized);
      }
    });

    return result.slice(
      0,
      MAX_PRODUCTS
    );
  }

  function saveItems(items) {
    var normalized =
      normalizeItems(items);

    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(normalized)
      );
    } catch (error) {
      console.warn(
        "[VSX9 Compare] Storage save failed:",
        error
      );
    }

    state.items = normalized;

    var detail = {
      items: normalized
    };

    document.dispatchEvent(
      new CustomEvent(
        EVENT_NAME,
        { detail: detail }
      )
    );

    window.dispatchEvent(
      new CustomEvent(
        EVENT_NAME,
        { detail: detail }
      )
    );
  }


  /* =========================================================
     PRICE
     ========================================================= */

  function getCurrency() {
    var page = getPage();

    return (
      page &&
      page.dataset.currency
    ) || "INR";
  }

  function formatPrice(value) {
    if (
      value === undefined ||
      value === null ||
      value === ""
    ) {
      return "—";
    }

    var number = Number(value);

    if (!Number.isFinite(number)) {
      return String(value);
    }

    /*
     * Shopify product .js prices are
     * generally returned in cents.
     */
    if (Math.abs(number) >= 100) {
      number = number / 100;
    }

    try {
      return new Intl.NumberFormat(
        "en-IN",
        {
          style: "currency",
          currency: getCurrency(),
          maximumFractionDigits: 0
        }
      ).format(number);
    } catch (error) {
      return "₹" +
        Math.round(number)
          .toLocaleString("en-IN");
    }
  }

  function getCurrentPrice(
    product,
    fallback
  ) {
    var variants =
      Array.isArray(product.variants)
        ? product.variants
        : [];

    var variant =
      variants.find(
        function (item) {
          return item.available;
        }
      ) ||
      variants[0];

    return formatPrice(
      firstValue(
        variant && variant.price,
        product.price,
        fallback
      )
    );
  }

  function getComparePrice(product) {
    var variants =
      Array.isArray(product.variants)
        ? product.variants
        : [];

    var variant =
      variants.find(
        function (item) {
          return item.compare_at_price;
        }
      );

    return formatPrice(
      firstValue(
        variant &&
          variant.compare_at_price,
        product.compare_at_price
      )
    );
  }

  function getDiscount(product) {
    var variants =
      Array.isArray(product.variants)
        ? product.variants
        : [];

    var variant =
      variants.find(
        function (item) {
          return (
            Number(item.compare_at_price) >
            Number(item.price)
          );
        }
      );

    var price = variant
      ? Number(variant.price)
      : Number(product.price);

    var comparePrice = variant
      ? Number(variant.compare_at_price)
      : Number(product.compare_at_price);

    if (
      !price ||
      !comparePrice ||
      comparePrice <= price
    ) {
      return "—";
    }

    var discount = Math.round(
      (
        (comparePrice - price) /
        comparePrice
      ) * 100
    );

    return discount > 0
      ? discount + "% OFF"
      : "—";
  }


  /* =========================================================
     BASIC PRODUCT DATA
     ========================================================= */

  function getAvailability(product) {
    var variants =
      Array.isArray(product.variants)
        ? product.variants
        : [];

    var available =
      variants.some(
        function (variant) {
          return variant.available;
        }
      );

    if (product.available === true) {
      available = true;
    }

    if (
      product.available === false &&
      !variants.length
    ) {
      available = false;
    }

    return available
      ? {
          text: "In stock",
          className:
            "vsx9-compare__availability"
        }
      : {
          text: "Out of stock",
          className:
            "vsx9-compare__availability " +
            "vsx9-compare__availability--out"
        };
  }

  function getVariantSummary(product) {
    var variants =
      Array.isArray(product.variants)
        ? product.variants
        : [];

    if (!variants.length) {
      return "—";
    }

    return variants.length === 1
      ? "1 variant"
      : variants.length + " variants";
  }

  function getOptions(product) {
    var options =
      Array.isArray(product.options)
        ? product.options
        : [];

    if (!options.length) {
      return "—";
    }

    return options
      .map(function (option) {
        return typeof option === "string"
          ? option
          : firstValue(
              option.name,
              ""
            );
      })
      .filter(Boolean)
      .join(", ") || "—";
  }

  function getProductImage(
    product,
    fallback
  ) {
    return firstValue(
      product.featured_image,
      product.featuredImage,
      product.images &&
        product.images[0],
      fallback,
      ""
    );
  }


  /* =========================================================
     DYNAMIC SPECIFICATION EXTRACTION
     ========================================================= */

  function isSpecHeader(cells) {
    if (!cells || cells.length < 2) {
      return false;
    }

    var first =
      normalizeSpecKey(cells[0]);

    var second =
      normalizeSpecKey(cells[1]);

    return (
      (
        first === "specification" ||
        first === "specifications"
      ) &&
      (
        second === "details" ||
        second === "detail"
      )
    );
  }

  function tableToSpecifications(table) {
    if (!table) {
      return [];
    }

    var rows = Array.prototype.slice.call(
      table.querySelectorAll("tr")
    );

    var result = [];

    rows.forEach(
      function (row, index) {
        var cells =
          Array.prototype.slice.call(
            row.querySelectorAll(
              "th, td"
            )
          )
          .map(function (cell) {
            return cleanText(
              cell.textContent
            );
          })
          .filter(Boolean);

        if (cells.length < 2) {
          return;
        }

        if (
          index === 0 &&
          isSpecHeader(cells)
        ) {
          return;
        }

        var label =
          cleanText(cells[0])
            .replace(/:$/, "");

        var value =
          cells.slice(1).join(" ");

        value = cleanText(value);

        if (!label || !value) {
          return;
        }

        /*
         * Ignore accidental header rows.
         */
        var labelKey =
          normalizeSpecKey(label);

        if (
          labelKey === "specification" ||
          labelKey === "specifications"
        ) {
          return;
        }

        result.push({
          label: label,
          value: value
        });
      }
    );

    return result;
  }

  function getTableScore(table) {
    var text =
      cleanText(
        table.textContent
      ).toLowerCase();

    var rows =
      table.querySelectorAll("tr");

    var score = rows.length;

    if (
      text.indexOf("processor") !== -1
    ) {
      score += 30;
    }

    if (
      text.indexOf("display") !== -1
    ) {
      score += 20;
    }

    if (
      text.indexOf("graphics") !== -1
    ) {
      score += 20;
    }

    if (
      text.indexOf("memory") !== -1
    ) {
      score += 20;
    }

    if (
      text.indexOf("storage") !== -1
    ) {
      score += 20;
    }

    var firstRow =
      table.querySelector(
        "tr:first-child"
      );

    if (firstRow) {
      var cells =
        Array.prototype.slice.call(
          firstRow.querySelectorAll(
            "th, td"
          )
        ).map(function (cell) {
          return cleanText(
            cell.textContent
          );
        });

      if (isSpecHeader(cells)) {
        score += 100;
      }
    }

    return score;
  }

  function extractSpecifications(doc) {
    if (!doc) {
      return [];
    }

    var tables =
      Array.prototype.slice.call(
        doc.querySelectorAll("table")
      );

    if (!tables.length) {
      return [];
    }

    tables.sort(
      function (a, b) {
        return (
          getTableScore(b) -
          getTableScore(a)
        );
      }
    );

    var result = [];
    var seen = Object.create(null);

    tables.forEach(
      function (table, index) {
        var specs =
          tableToSpecifications(
            table
          );

        /*
         * Primary specification table gets
         * priority. Other useful tables can add
         * unique specifications.
         */
        if (
          index > 0 &&
          specs.length < 2
        ) {
          return;
        }

        specs.forEach(
          function (spec) {
            var key =
              normalizeSpecKey(
                spec.label
              );

            if (
              !key ||
              seen[key]
            ) {
              return;
            }

            seen[key] = true;
            result.push(spec);
          }
        );
      }
    );

    return result;
  }

  function extractDefinitionList(
    doc
  ) {
    if (!doc) {
      return [];
    }

    var result = [];

    Array.prototype.slice.call(
      doc.querySelectorAll("dl")
    ).forEach(
      function (dl) {
        Array.prototype.slice.call(
          dl.querySelectorAll("dt")
        ).forEach(
          function (dt) {
            var dd =
              dt.nextElementSibling;

            if (
              !dd ||
              dd.tagName.toLowerCase() !==
                "dd"
            ) {
              return;
            }

            var label =
              cleanText(dt.textContent);

            var value =
              cleanText(dd.textContent);

            if (label && value) {
              result.push({
                label: label,
                value: value
              });
            }
          }
        );
      }
    );

    return result;
  }

  function extractSpecsFromHTML(
    html
  ) {
    if (!html) {
      return [];
    }

    try {
      var parser =
        new DOMParser();

      var doc =
        parser.parseFromString(
          html,
          "text/html"
        );

      /*
       * First look for common specification
       * containers.
       */
      var container =
        doc.querySelector(
          "[data-product-specifications], " +
          "[data-product-specs], " +
          ".product-specifications, " +
          ".product-specs, " +
          ".product__specifications, " +
          ".product__specs"
        );

      if (container) {
        var directTables =
          Array.prototype.slice.call(
            container.querySelectorAll(
              "table"
            )
          );

        var directSpecs = [];

        directTables.forEach(
          function (table) {
            directSpecs =
              directSpecs.concat(
                tableToSpecifications(
                  table
                )
              );
          }
        );

        if (directSpecs.length) {
          var unique =
            Object.create(null);

          return directSpecs.filter(
            function (spec) {
              var key =
                normalizeSpecKey(
                  spec.label
                );

              if (
                !key ||
                unique[key]
              ) {
                return false;
              }

              unique[key] = true;
              return true;
            }
          );
        }
      }

      var tableSpecs =
        extractSpecifications(doc);

      if (tableSpecs.length) {
        return tableSpecs;
      }

      return extractDefinitionList(doc);

    } catch (error) {
      console.warn(
        "[VSX9 Compare] Specification parse failed:",
        error
      );

      return [];
    }
  }

  function extractSpecsFromDescription(
    description
  ) {
    if (!description) {
      return [];
    }

    try {
      var parser =
        new DOMParser();

      var doc =
        parser.parseFromString(
          description,
          "text/html"
        );

      return extractSpecifications(
        doc
      );

    } catch (error) {
      return [];
    }
  }


  /* =========================================================
     SHOPIFY FETCH
     ========================================================= */

  async function fetchProductJSON(
    handle
  ) {
    var response =
      await fetch(
        "/products/" +
          encodeURIComponent(handle) +
          ".js",
        {
          method: "GET",
          headers: {
            Accept:
              "application/json"
          },
          credentials:
            "same-origin",
          cache: "no-store"
        }
      );

    if (!response.ok) {
      throw new Error(
        "Shopify product API: " +
        response.status
      );
    }

    return response.json();
  }

  async function fetchProductPage(
    handle
  ) {
    try {
      var response =
        await fetch(
          "/products/" +
            encodeURIComponent(handle),
          {
            method: "GET",
            headers: {
              Accept:
                "text/html"
            },
            credentials:
              "same-origin",
            cache: "no-store"
          }
        );

      if (!response.ok) {
        return "";
      }

      return response.text();

    } catch (error) {
      console.warn(
        "[VSX9 Compare] Product HTML fetch failed:",
        handle
      );

      return "";
    }
  }


  /* =========================================================
     MERGE PRODUCT
     ========================================================= */

  function mergeProduct(
    saved,
    product,
    specifications
  ) {
    if (!product) {
      return {
        saved: saved,
        api: null,

        id: saved.id,
        handle: saved.handle,
        title: saved.title || "Product",
        url: saved.url,
        image: saved.image,
        vendor: saved.vendor,
        price: saved.price,
        comparePrice:
          saved.comparePrice,
        variantId:
          saved.variantId,
        available:
          saved.available,

        specifications:
          specifications || []
      };
    }

    var variants =
      Array.isArray(
        product.variants
      )
        ? product.variants
        : [];

    var variant =
      variants.find(
        function (item) {
          return item.available;
        }
      ) ||
      variants[0];

    return {
      saved: saved,
      api: product,

      id: firstValue(
        product.id,
        saved.id
      ),

      handle: firstValue(
        product.handle,
        saved.handle
      ),

      title: firstValue(
        product.title,
        saved.title,
        "Product"
      ),

      url:
        "/products/" +
        encodeURIComponent(
          firstValue(
            product.handle,
            saved.handle
          )
        ),

      image: getProductImage(
        product,
        saved.image
      ),

      vendor: firstValue(
        product.vendor,
        saved.vendor
      ),

      variantId: firstValue(
        variant &&
          variant.id,
        saved.variantId
      ),

      price: firstValue(
        product.price,
        variant &&
          variant.price,
        saved.price
      ),

      comparePrice: firstValue(
        product.compare_at_price,
        variant &&
          variant.compare_at_price,
        saved.comparePrice
      ),

      available:
        product.available !==
        undefined
          ? product.available
          : saved.available,

      specifications:
        specifications || []
    };
  }


  async function fetchProduct(
    saved
  ) {
    if (!saved.handle) {
      return mergeProduct(
        saved,
        null,
        []
      );
    }

    try {
      /*
       * Fetch Shopify product JSON.
       */
      var product =
        await fetchProductJSON(
          saved.handle
        );

      /*
       * Fetch actual Shopify product
       * page. This is where your existing
       * Specifications / Details table
       * comes from.
       */
      var html =
        await fetchProductPage(
          saved.handle
        );

      /*
       * Primary source:
       * product page specification table.
       */
      var specifications =
        extractSpecsFromHTML(
          html
        );

      /*
       * Fallback:
       * Shopify product description.
       */
      if (!specifications.length) {
        specifications =
          extractSpecsFromDescription(
            product.description
          );
      }

      return mergeProduct(
        saved,
        product,
        specifications
      );

    } catch (error) {
      console.warn(
        "[VSX9 Compare] Product fetch failed:",
        saved.handle,
        error
      );

      return mergeProduct(
        saved,
        null,
        []
      );
    }
  }


  /* =========================================================
     LOAD PRODUCTS
     ========================================================= */

  async function loadProducts() {
    state.loading = true;

    renderLoading();

    state.items =
      normalizeItems(
        readStorage()
      );

    renderCount();

    if (!state.items.length) {
      state.products = [];
      state.loading = false;
      render();
      return;
    }

    var products =
      await Promise.all(
        state.items.map(
          function (item) {
            return fetchProduct(
              item
            );
          }
        )
      );

    state.products =
      products.filter(Boolean);

    state.loading = false;

    render();
  }


  /* =========================================================
     COUNT
     ========================================================= */

  function renderCount() {
    var countElement =
      document.querySelector(
        "[data-vsx9-compare-count]"
      );

    var statusElement =
      document.querySelector(
        "[data-vsx9-compare-status]"
      );

    var clearButton =
      document.querySelector(
        "[data-vsx9-compare-clear]"
      );

    var count =
      state.items.length;

    if (countElement) {
      countElement.textContent =
        count === 1
          ? "1 product"
          : count + " products";
    }

    if (statusElement) {
      if (count === 0) {
        statusElement.textContent =
          "Select products to compare";
      } else if (count === 1) {
        statusElement.textContent =
          "Add another product to compare";
      } else {
        statusElement.textContent =
          "Comparing " +
          count +
          " products";
      }
    }

    if (clearButton) {
      clearButton.disabled =
        count === 0;
    }
  }


  /* =========================================================
     VISIBILITY
     ========================================================= */

  function renderVisibility() {
    var empty =
      document.querySelector(
        "[data-vsx9-compare-empty]"
      );

    var tableWrapper =
      document.querySelector(
        "[data-vsx9-compare-table-wrapper]"
      );

    var hasProducts =
      state.products.length > 0;

    if (empty) {
      empty.hidden =
        hasProducts;
    }

    if (tableWrapper) {
      tableWrapper.hidden =
        !hasProducts;
    }
  }


  function renderLoading() {
    var table =
      document.querySelector(
        "[data-vsx9-compare-table]"
      );

    var wrapper =
      document.querySelector(
        "[data-vsx9-compare-table-wrapper]"
      );

    if (!table) {
      return;
    }

    if (wrapper) {
      wrapper.hidden = false;
    }

    table.innerHTML =
      '<div class="vsx9-compare__loading">' +
      "Loading comparison..." +
      "</div>";
  }


  /* =========================================================
     TABLE ROWS
     ========================================================= */

  function buildRows() {
    var groups = [
      {
        group: "Product Information",
        rows: [
          {
            label: "Brand / Vendor",
            key: "vendor"
          },
          {
            label: "Availability",
            key: "availability"
          },
          {
            label: "Product Type",
            key: "product_type"
          },
          {
            label: "Variants",
            key: "variants"
          },
          {
            label: "Options",
            key: "options"
          }
        ]
      },

      {
        group: "Pricing",
        rows: [
          {
            label: "Current Price",
            key: "price"
          },
          {
            label: "Original Price",
            key: "compare_price"
          },
          {
            label: "Discount",
            key: "discount"
          }
        ]
      }
    ];

    /*
     * IMPORTANT:
     *
     * No specification names are hard-coded here.
     *
     * Every specification row comes directly
     * from the Shopify product data.
     */
    var map =
      Object.create(null);

    var specificationRows = [];

    state.products.forEach(
      function (product) {
        var specs =
          Array.isArray(
            product.specifications
          )
            ? product.specifications
            : [];

        specs.forEach(
          function (spec) {
            var key =
              normalizeSpecKey(
                spec.label
              );

            if (
              !key ||
              map[key]
            ) {
              return;
            }

            map[key] = true;

            specificationRows.push({
              label: spec.label,
              key: "spec:" + key
            });
          }
        );
      }
    );

    if (specificationRows.length) {
      groups.push({
        group: "Specifications",
        rows: specificationRows
      });
    }

    return groups;
  }


  function getSpecificationValue(
    product,
    key
  ) {
    var target =
      String(key)
        .replace(/^spec:/, "");

    var specs =
      Array.isArray(
        product.specifications
      )
        ? product.specifications
        : [];

    var match =
      specs.find(
        function (spec) {
          return (
            normalizeSpecKey(
              spec.label
            ) === target
          );
        }
      );

    return match
      ? match.value
      : "—";
  }


  function getRowValue(
    product,
    key
  ) {
    var api =
      product.api || {};

    /*
     * Dynamic Shopify specification.
     */
    if (
      String(key).indexOf(
        "spec:"
      ) === 0
    ) {
      return getSpecificationValue(
        product,
        key
      );
    }

    switch (key) {
      case "vendor":
        return firstValue(
          product.vendor,
          api.vendor,
          "—"
        );

      case "availability":
        return getAvailability(
          api
        );

      case "product_type":
        return firstValue(
          api.product_type,
          "—"
        );

      case "variants":
        return getVariantSummary(
          api
        );

      case "options":
        return getOptions(
          api
        );

      case "price":
        return getCurrentPrice(
          api,
          product.price
        );

      case "compare_price":
        return (
          getComparePrice(api) !== "—"
            ? getComparePrice(api)
            : (
                product.comparePrice
                  ? formatPrice(
                      product.comparePrice
                    )
                  : "—"
              )
        );

      case "discount":
        return getDiscount(api);

      default:
        return "—";
    }
  }


  /* =========================================================
     BEST VALUE
     ========================================================= */

  function getNumericPrice(
    product
  ) {
    var api =
      product.api || {};

    var variants =
      Array.isArray(
        api.variants
      )
        ? api.variants
        : [];

    var variant =
      variants.find(
        function (item) {
          return item.available;
        }
      ) ||
      variants[0];

    var value =
      firstValue(
        variant &&
          variant.price,
        api.price,
        product.price
      );

    var number =
      Number(value);

    return Number.isFinite(number)
      ? number
      : 0;
  }

  function getBestPriceIndexes() {
    if (
      state.products.length < 2
    ) {
      return [];
    }

    var values =
      state.products.map(
        getNumericPrice
      );

    var valid =
      values.filter(
        function (value) {
          return value > 0;
        }
      );

    if (!valid.length) {
      return [];
    }

    var minimum =
      Math.min.apply(
        Math,
        valid
      );

    var indexes = [];

    values.forEach(
      function (
        value,
        index
      ) {
        if (
          value > 0 &&
          value === minimum
        ) {
          indexes.push(index);
        }
      }
    );

    return indexes;
  }


  /* =========================================================
     PRODUCT HEADER
     ========================================================= */

  function renderProductHeader() {
    var count =
      state.products.length;

    var html =
      '<div class="vsx9-compare__table-head" ' +
      'style="--vsx9-product-count:' +
      count +
      ';">';

    html +=
      '<div class="vsx9-compare__head-label">' +
      "Product" +
      "</div>";

    state.products.forEach(
      function (product) {
        var title =
          product.title ||
          "Product";

        var vendor =
          product.vendor ||
          "";

        var image =
          product.image ||
          "";

        var url =
          product.url ||
          "#";

        var removeId =
          product.id ||
          product.handle;

        html +=
          '<div class="vsx9-compare__product-head">';

        /*
         * Remove product.
         */
        html +=
          '<button ' +
          'type="button" ' +
          'class="vsx9-compare__product-remove" ' +
          'data-vsx9-compare-remove="' +
          escapeHTML(removeId) +
          '" ' +
          'aria-label="Remove ' +
          escapeHTML(title) +
          '" ' +
          'title="Remove">' +
          "×" +
          "</button>";

        if (image) {
          html +=
            '<a ' +
            'class="vsx9-compare__product-image" ' +
            'href="' +
            escapeHTML(url) +
            '">' +

            '<img ' +
            'src="' +
            escapeHTML(image) +
            '" ' +
            'alt="' +
            escapeHTML(title) +
            '" ' +
            'loading="lazy">' +

            "</a>";
        } else {
          html +=
            '<div class="vsx9-compare__product-image">' +
            "<span>—</span>" +
            "</div>";
        }

        html +=
          '<div class="vsx9-compare__product-meta">';

        if (vendor) {
          html +=
            '<div class="vsx9-compare__product-vendor">' +
            escapeHTML(vendor) +
            "</div>";
        }

        html +=
          '<a ' +
          'class="vsx9-compare__product-title" ' +
          'href="' +
          escapeHTML(url) +
          '">' +
          escapeHTML(title) +
          "</a>";

        html +=
          "</div>";

        html +=
          "</div>";
      }
    );

    html += "</div>";

    return html;
  }


  /* =========================================================
     TABLE
     ========================================================= */

  function renderTable() {
    var table =
      document.querySelector(
        "[data-vsx9-compare-table]"
      );

    if (!table) {
      return;
    }

    var count =
      state.products.length;

    var bestIndexes =
      getBestPriceIndexes();

    var html =
      renderProductHeader();

    var groups =
      buildRows();

    groups.forEach(
      function (group) {
        html +=
          '<section class="vsx9-compare__group">';

        html +=
          '<div class="vsx9-compare__group-title">' +
          escapeHTML(
            group.group
          ) +
          "</div>";

        group.rows.forEach(
          function (row) {
            var values =
              state.products.map(
                function (product) {
                  return getRowValue(
                    product,
                    row.key
                  );
                }
              );

            /*
             * Compare raw displayed values.
             */
            var rawValues =
              values.map(
                function (value) {
                  return typeof value ===
                    "object"
                    ? value.text
                    : String(value);
                }
              );

            var same =
              rawValues.length > 1 &&
              rawValues.every(
                function (value) {
                  return (
                    value ===
                    rawValues[0]
                  );
                }
              );

            html +=
              '<div ' +
              'class="vsx9-compare__row" ' +
              'data-vsx9-same="' +
              (
                same
                  ? "true"
                  : "false"
              ) +
              '" ' +
              'style="--vsx9-product-count:' +
              count +
              ';">';

            html +=
              '<div class="vsx9-compare__label">' +
              escapeHTML(
                row.label
              ) +
              "</div>";

            state.products.forEach(
              function (
                product,
                index
              ) {
                var value =
                  values[index];

                var text =
                  typeof value ===
                    "object"
                    ? value.text
                    : value;

                var classes =
                  "vsx9-compare__value";

                if (
                  row.key ===
                  "price"
                ) {
                  classes +=
                    " vsx9-compare__value--price";
                }

                if (
                  row.key ===
                  "availability"
                ) {
                  classes +=
                    " " +
                    value.className;
                }

                if (
                  row.key ===
                    "price" &&
                  bestIndexes.includes(
                    index
                  )
                ) {
                  classes +=
                    " vsx9-compare__value--best";
                }

                if (
                  String(text) ===
                  "—"
                ) {
                  classes +=
                    " vsx9-compare__value--missing";
                }

                html +=
                  '<div class="' +
                  classes +
                  '">';

                if (
                  row.key ===
                    "price" &&
                  bestIndexes.includes(
                    index
                  )
                ) {
                  html +=
                    "<span>" +
                    escapeHTML(
                      text
                    ) +
                    "</span>" +

                    '<span class="vsx9-compare__best-badge">' +
                    "Best Value" +
                    "</span>";
                } else {
                  html +=
                    escapeHTML(
                      text
                    );
                }

                html +=
                  "</div>";
              }
            );

            html +=
              "</div>";
          }
        );

        html +=
          "</section>";
      }
    );

    table.innerHTML =
      html;

    renderVisibility();
  }


  /* =========================================================
     MAIN RENDER
     ========================================================= */

  function render() {
    renderCount();

    if (
      !state.products.length
    ) {
      var table =
        document.querySelector(
          "[data-vsx9-compare-table]"
        );

      if (table) {
        table.innerHTML = "";
      }

      renderVisibility();
      return;
    }

    renderTable();
  }


  /* =========================================================
     DIFFERENCES
     ========================================================= */

  function toggleDifferences() {
    state.onlyDifferences =
      !state.onlyDifferences;

    var page =
      getPage();

    var button =
      document.querySelector(
        "[data-vsx9-differences-toggle]"
      );

    if (page) {
      page.dataset.vsx9OnlyDifferences =
        String(
          state.onlyDifferences
        );
    }

    if (button) {
      button.setAttribute(
        "aria-pressed",
        String(
          state.onlyDifferences
        )
      );
    }
  }


  /* =========================================================
     CLEAR
     ========================================================= */

  function clearCompare() {
    saveItems([]);

    state.items = [];
    state.products = [];

    render();
  }


  /* =========================================================
     REMOVE
     ========================================================= */

  function removeCompare(
    id
  ) {
    var target =
      String(id || "");

    var remaining =
      state.items.filter(
        function (item) {
          return (
            String(
              item.id || ""
            ) !== target &&
            String(
              item.handle || ""
            ) !== target
          );
        }
      );

    saveItems(
      remaining
    );

    loadProducts();
  }


  /* =========================================================
     EVENTS
     ========================================================= */

  function bindEvents() {

    document.addEventListener(
      "click",
      function (event) {

        var differenceButton =
          event.target.closest(
            "[data-vsx9-differences-toggle]"
          );

        if (
          differenceButton
        ) {
          event.preventDefault();

          toggleDifferences();

          return;
        }


        var clearButton =
          event.target.closest(
            "[data-vsx9-compare-clear]"
          );

        if (clearButton) {
          event.preventDefault();

          if (
            state.items.length
          ) {
            clearCompare();
          }

          return;
        }


        var removeButton =
          event.target.closest(
            "[data-vsx9-compare-remove]"
          );

        if (removeButton) {
          event.preventDefault();

          removeCompare(
            removeButton.dataset
              .vsx9CompareRemove
          );
        }
      }
    );


    /*
     * Cross-tab synchronization.
     */
    window.addEventListener(
      "storage",
      function (event) {
        if (
          event.key ===
          STORAGE_KEY
        ) {
          loadProducts();
        }
      }
    );


    /*
     * Same-tab compare synchronization.
     */
    document.addEventListener(
      EVENT_NAME,
      function () {
        loadProducts();
      }
    );

    window.addEventListener(
      EVENT_NAME,
      function () {
        loadProducts();
      }
    );
  }


  /* =========================================================
     PUBLIC API
     ========================================================= */

  window.VSX9Compare = {

    key:
      STORAGE_KEY,

    getItems:
      function () {
        return normalizeItems(
          readStorage()
        );
      },

    has:
      function (id) {
        var target =
          String(id);

        return readStorage()
          .some(
            function (item) {
              return (
                String(
                  firstValue(
                    item.id,
                    item.productId,
                    item.product_id
                  )
                ) === target
              );
            }
          );
      },

    add:
      function (item) {
        var current =
          normalizeItems(
            readStorage()
          );

        var normalized =
          normalizeItem(
            item
          );

        if (!normalized) {
          return false;
        }

        var exists =
          current.some(
            function (existing) {
              return (
                (
                  normalized.id &&
                  existing.id &&
                  normalized.id ===
                    existing.id
                ) ||
                (
                  normalized.handle &&
                  existing.handle &&
                  normalized.handle ===
                    existing.handle
                )
              );
            }
          );

        if (exists) {
          return true;
        }

        if (
          current.length >=
          MAX_PRODUCTS
        ) {
          return false;
        }

        current.push(
          normalized
        );

        saveItems(
          current
        );

        return true;
      },

    remove:
      function (id) {
        removeCompare(id);
      },

    clear:
      function () {
        clearCompare();
      },

    reload:
      function () {
        loadProducts();
      }
  };


  /* =========================================================
     INITIALIZE
     ========================================================= */

  function init() {
    var page =
      getPage();

    if (!page) {
      return;
    }

    var max =
      Number(
        page.dataset.maxProducts
      );

    if (
      Number.isFinite(max) &&
      max > 0
    ) {
      MAX_PRODUCTS =
        Math.min(
          max,
          4
        );
    }

    bindEvents();

    state.items =
      normalizeItems(
        readStorage()
      );

    renderCount();

    loadProducts();
  }


  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }

})();